<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  mounted() {
    setTimeout(() => {
      // Redirect to a different URL after 3 seconds

      window.location.href = "https://theodoreimonigie.web.app/";
    }, 3000); // 3000 milliseconds = 3 seconds
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
